import AssetsLimitWarning from './AssetsLimitWarning.container';

export default AssetsLimitWarning;
